//Libs
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";

//Local
import * as strings from "../../strings";
import AddNewPurchaseOrderForm, {
  PurchaseOrderFormValues,
} from "./AddNewPurchaseOrderForm";
import HeadingOne from "../HeadingOne";
import { ExistingVendor } from "../../models/vendor";

interface Props {
  /* DATA */
  siteKey: string;
  vendorList: ExistingVendor[];
  craftRecordID?: string | null;
  /* FUNCTIONS */
  handleSave: (formValues: PurchaseOrderFormValues) => Promise<void>;
  navigateBack?: () => void; // Optional custom navigation function
}

export default function AddNewPurchaseOrderPage(props: Props) {
  const navigate = useNavigate();

  // Handle navigation back to previous page
  const handleNavigateBack = () => {
    if (props.navigateBack) {
      props.navigateBack();
    } else {
      navigate(-1); // Default to browser history back
    }
  };

  return (
    <div className="mx-auto w-full px-4 py-6">
      {/* Header */}
      <div className="mb-6 flex items-center justify-between">
        <div className="flex items-center">
          <button
            type="button"
            onClick={handleNavigateBack}
            className="mr-4 rounded-full p-2 hover:bg-gray-100"
            aria-label="Go back"
          >
            <ArrowLeftIcon className="h-6 w-6 text-gray-600" />
          </button>
          <HeadingOne fontSize="text-2xl">
            {strings.NEW_PURCHASE_ORDER}
          </HeadingOne>
        </div>
      </div>

      {/* Main content */}
      <div className="rounded-lg bg-white shadow-md">
        <AddNewPurchaseOrderForm
          className="flex flex-col space-y-8 p-8 text-lg"
          handleSave={async (formValues) => {
            console.log("formValues", formValues);
            await props.handleSave(formValues);
            handleNavigateBack(); // Navigate back after successful save
          }}
          setAddPurchaseOrderFormOpen={handleNavigateBack}
          siteKey={props.siteKey}
          vendorList={props.vendorList}
          craftRecordID={props.craftRecordID}
        />
      </div>
    </div>
  );
}
